import { studentReducerTypes, studentSingleReducerTypes } from 'types';

const studentDataUpdateState: studentReducerTypes.IStudentDataUpdate = {
    // Form
    id: null,
    name: '',
    email: '',
    city: '',
    collegeName: '',
    department: '',
    event_id: null,
    mobileNumber: '',
    nationality: '',
    registerType: '',
    state: '',
    whichYear: '',

    // Reducer
    isLoading: false,

    // Response
    message: '',
    status: false,
};

const studentDataState: studentReducerTypes.IStudentData = {
    // Form
    page: 1,
    search_word: '',

    // Reducer
    isLoading: false,

    // Response
    data: [],
    current_page: 1,
    last_page: 1,
    to: 0,
    total: 0,
    status: false,
};

const studentDataSingleState: studentSingleReducerTypes.IStudentDataSingle = {
    data: null,
    isLoading: false,
    status: false,
    studentId: null,
};

export { studentDataUpdateState, studentDataState, studentDataSingleState };
